import { useSelector } from "react-redux";
import {
    CarregaDescarregaVolumeMercadoriaActions,
    INITIAL as CarregaDescarregaVolumeMercadoriaState
} from "./carregaDescarregaVolumeMercadoria";

export const useCarregaDescarregaVolumeMercadoria = () => {
    // @ts-ignore
    const state = useSelector(state => state.carregaDescarregaVolumeMercadoriaReducer);
    return {
        actions: {
            ...CarregaDescarregaVolumeMercadoriaActions
        },
        state
    };
};